export const getQueryParams = (url) => {
  const params = new URLSearchParams(url.split("?")[1]);
  return {
    window: params.get("window"),
    start: params.get("start"),
    end: params.get("end"),
  };
};
